// ==============================
// 파일명 : src/constants/users/validation.js
// 역할 : 유저 관련 폼에서 재사용하는 이메일 정규식과 오류 문구를 한 곳에 보관해 입력 검증 로직을 일관되게 유지하도록 지원
// 수정일 : 2025-10-14
// ==============================

export const USER_EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/; // [수정] 이메일 형식 확인용 정규식

export const USER_FORM_VALIDATION_MESSAGES = {
  emailRequired: "이메일을 입력해주세요.", // [수정] 이메일 미입력 시 안내 문구
  emailInvalid: "이메일 형식이 올바르지 않습니다.", // [수정] 이메일 형식 오류 안내 문구
};